import { render, staticRenderFns } from "./WorkshopAddClient.vue?vue&type=template&id=fc1c4330&"
import script from "./WorkshopAddClient.vue?vue&type=script&lang=ts&"
export * from "./WorkshopAddClient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports